import { CircularProgress } from "@mui/material";
import React from "react";

import ActionItem from "./ActionItem";
import NoData from "./NoData";

export default function ActionItemsList({
  actionItemType,
  itemsList,
  setActiveActionItem,
  setOpenAddActionItemModal,
  setOpenCompleteModal,
  isLoading = false,
}) {
  return (
    <div className="min-h-[290px] w-[25%] border-r-2 border-solid border-slate-100 p-2 last:border-none">
      {isLoading ? (
        <div className="flex items-center justify-center py-8">
          <CircularProgress size={24} />
        </div>
      ) : itemsList && itemsList.length > 0 ? (
        itemsList.map((item) => (
          <ActionItem
            key={item.pk ?? item.id}
            item={item}
            actionItemType={actionItemType}
            setActiveActionItem={setActiveActionItem}
            setOpenAddActionItemModal={setOpenAddActionItemModal}
            setOpenCompleteModal={setOpenCompleteModal}
          />
        ))
      ) : (
        <NoData />
      )}
    </div>
  );
}
